import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import EuroSymbol from '@mui/icons-material/EuroSymbol';
import WarrantyDataListSummary from './WarrantyDataListSummary';
import { Link } from '@mui/material';
import { withParams } from 'providers/ParamsConsumer';
import WarrantyDataContentContainer from './WarrantyDataContentContainer';
import { RightsContext } from 'providers/RightsContext';
import { CollapseCard, Typography } from '@totalsoft/rocket-ui';

const WarrantyDataCardTitle = React.memo(({ folderOffer, onOpenFolderOffer, expanded }) => {
  const { t } = useTranslation();

  return folderOffer && expanded ? (
    <div style={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'pre-wrap' }}>
      <Typography fontWeight='bold' variant='subtitle1'>
        {t('Document.Decision.Warranties.Title') + ' '}
      </Typography>
      <Link
        variant='subtitle1'
        component='button'
        fontWeight='bold'
        onClick={onOpenFolderOffer(folderOffer.offerId, folderOffer.offerSiteId)}
      >
        {folderOffer.documentNumber}
      </Link>
    </div>
  ) : (
    <Typography fontWeight='bold' variant='subtitle1'>
      {t('OfferEdit.Warranty.Title')}
    </Typography>
  );
});

WarrantyDataCardTitle.displayName = 'WarrantyDataCardTitle';
WarrantyDataCardTitle.propTypes = {
  folderOffer: PropTypes.object,
  onOpenFolderOffer: PropTypes.func,
  expanded: PropTypes.bool.isRequired
};

const WarrantyDataCard = React.memo(
  ({ documentId, siteId, warrantiesSummary, toggleExpanded, expanded, folderOffer, openFolderOffer, params }) => {
    const { documentWarrantiesWrite } = useContext(RightsContext);
    return (
      <CollapseCard
        id={'warrantyDataCard'}
        icon={EuroSymbol}
        title={<WarrantyDataCardTitle folderOffer={folderOffer} onOpenFolderOffer={openFolderOffer} expanded={expanded} />}
        subheader={
          warrantiesSummary?.length > 0 || (!folderOffer && warrantiesSummary?.length === 0) ? (
            <WarrantyDataListSummary warranties={warrantiesSummary} warrantyItemVisible={params.fSWarrantyDetailsVisibility} />
          ) : null
        }
        toggleOnHeaderClick
        hideSubheaderOnExpand
        expanded={warrantiesSummary?.length === 0 && !documentWarrantiesWrite && !folderOffer ? false : expanded}
        onToggle={toggleExpanded}
      >
        {expanded && (
          <WarrantyDataContentContainer
            folderOffer={folderOffer}
            documentId={folderOffer ? folderOffer.offerId : documentId}
            siteId={folderOffer ? folderOffer.offerSiteId : siteId}
          />
        )}
      </CollapseCard>
    );
  }
);

WarrantyDataCard.displayName = 'WarrantyDataCard';
WarrantyDataCard.propTypes = {
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  warrantiesSummary: PropTypes.array.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  folderOffer: PropTypes.object,
  openFolderOffer: PropTypes.func,
  params: PropTypes.object.isRequired
};

export default withParams(WarrantyDataCard);
